import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if(!d) return '—'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<1?'just now':m<60?`${m}m ago`:`${Math.floor(m/60)}h ago`; }

const ACTION_META = {
  warn:      { color:'#d97706', bg:'#fef3c7', label:'Warn',      icon:'⚠️'  },
  block:     { color:'#dc2626', bg:'#fee2e2', label:'Block',     icon:'🚫'  },
  isolate:   { color:'#7c3aed', bg:'#ede9fe', label:'Isolate',   icon:'🔒'  },
  remediate: { color:'#1d4ed8', bg:'#dbeafe', label:'Remediate', icon:'🔧'  },
  notify:    { color:'#16a34a', bg:'#dcfce7', label:'Notify',    icon:'🔔'  },
};
const STATE_META = {
  compliant:    { color:'#16a34a', bg:'#dcfce7', label:'Compliant'    },
  warned:       { color:'#d97706', bg:'#fef3c7', label:'Warned'       },
  blocked:      { color:'#dc2626', bg:'#fee2e2', label:'Blocked'      },
  isolated:     { color:'#7c3aed', bg:'#ede9fe', label:'Isolated'     },
  remediating:  { color:'#1d4ed8', bg:'#dbeafe', label:'Remediating'  },
};

const DEF = { name:'', description:'', active:true, priority:100, action:'warn',
  conditions:{ complianceScore:{ lt:50 } }, actionConfig:{} };

export default function ConditionalAccess({ user }) {
  const [rules,   setRules]   = useState([]);
  const [states,  setStates]  = useState([]);
  const [tab,     setTab]     = useState('rules');
  const [loading, setLoading] = useState(true);
  const [msg,     setMsg]     = useState({ text:'', type:'' });
  const [showForm,setShowForm]= useState(false);
  const [form,    setForm]    = useState(DEF);
  const [saving,  setSaving]  = useState(false);
  const [evaluating, setEvaluating] = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }

  const load = useCallback(async () => {
    try {
      const [rr, ss] = await Promise.all([
        axios.get('/api/conditional-access/rules', auth()),
        axios.get('/api/conditional-access/states', auth()),
      ]);
      setRules(rr.data); setStates(ss.data);
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(()=>{ load(); },[load]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try {
      await axios.post('/api/conditional-access/rules', form, auth());
      flash('Rule created'); setShowForm(false); setForm(DEF); load();
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); }
    finally { setSaving(false); }
  }

  async function del(id) {
    if (!window.confirm('Delete this rule?')) return;
    try { await axios.delete(`/api/conditional-access/rules/${id}`, auth()); flash('Deleted'); load(); }
    catch(e) { flash('Failed','error'); }
  }

  async function evaluate() {
    setEvaluating(true);
    try { const r = await axios.post('/api/conditional-access/evaluate', {}, auth()); flash(`Evaluated ${r.data.evaluated} devices`); load(); }
    catch(e) { flash('Evaluation failed','error'); }
    finally { setEvaluating(false); }
  }

  const violations = states.filter(s=>s.state!=='compliant');

  return (
    <div style={{padding:24}}>
      {msg.text && <div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div>
          <h2 style={{margin:0,fontSize:20,fontWeight:700}}>Conditional Access</h2>
          <p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Block, warn, or remediate devices based on compliance, BitLocker, AV status</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={evaluate} disabled={evaluating} style={{background:evaluating?'#94a3b8':'#f1f5f9',border:'1px solid #e2e8f0',color:'#475569',borderRadius:8,padding:'9px 16px',fontWeight:600,cursor:evaluating?'default':'pointer',fontSize:13}}>{evaluating?'Evaluating...':'▶ Evaluate Now'}</button>
          <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Rule</button>
        </div>
      </div>

      {/* Summary stats */}
      <div style={{display:'flex',gap:12,marginBottom:20,flexWrap:'wrap'}}>
        {[
          ['Total Rules', rules.length, '#1e40af'],
          ['Active Rules', rules.filter(r=>r.active).length, '#16a34a'],
          ['Violations', violations.length, violations.length>0?'#dc2626':'#16a34a'],
          ['Blocked', states.filter(s=>s.state==='blocked').length, '#dc2626'],
        ].map(([label,val,color])=>(
          <div key={label} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:10,padding:'14px 20px',minWidth:120}}>
            <div style={{fontSize:24,fontWeight:800,color}}>{val}</div>
            <div style={{fontSize:12,color:'#64748b'}}>{label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{display:'flex',gap:2,marginBottom:16,borderBottom:'2px solid #f1f5f9'}}>
        {[['rules',`Rules (${rules.length})`],['violations',`Active Violations (${violations.length})`]].map(([id,label])=>(
          <button key={id} onClick={()=>setTab(id)} style={{padding:'8px 16px',border:'none',borderBottom:tab===id?'2px solid #1e40af':'2px solid transparent',background:'none',cursor:'pointer',fontWeight:600,fontSize:13,color:tab===id?'#1e40af':'#64748b',marginBottom:-2}}>{label}</button>
        ))}
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> : tab==='rules' ? (
        rules.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>🛡</div><div style={{fontWeight:600,marginTop:12}}>No rules yet</div></div> : (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(360px,1fr))',gap:14}}>
            {rules.map(r=>{
              const am = ACTION_META[r.action]||ACTION_META.warn;
              return (
                <div key={r.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                    <div>
                      <div style={{fontWeight:700,fontSize:14}}>{r.name}</div>
                      {r.description && <div style={{fontSize:12,color:'#64748b',marginTop:2}}>{r.description}</div>}
                    </div>
                    <div style={{display:'flex',gap:6}}>
                      <span style={{background:am.bg,color:am.color,borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700}}>{am.icon} {am.label}</span>
                      <span style={{background:r.active?'#dcfce7':'#fee2e2',color:r.active?'#16a34a':'#dc2626',borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700}}>{r.active?'ON':'OFF'}</span>
                    </div>
                  </div>
                  <div style={{background:'#f8fafc',borderRadius:7,padding:'8px 12px',marginBottom:10,fontSize:12,fontFamily:'monospace',color:'#475569'}}>
                    {JSON.stringify(r.conditions,null,2).substring(0,120)}
                  </div>
                  <div style={{fontSize:11,color:'#94a3b8',marginBottom:12}}>Priority {r.priority} · {r.activeViolations||0} active violations · Evaluated {ts(r.lastEvalAt)}</div>
                  <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
                    <button onClick={()=>del(r.id)} style={{background:'#fee2e2',border:'none',borderRadius:7,padding:'6px 10px',fontSize:12,cursor:'pointer',color:'#dc2626'}}>🗑</button>
                  </div>
                </div>
              );
            })}
          </div>
        )
      ) : (
        violations.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>✅</div><div style={{fontWeight:600,marginTop:12}}>No active violations</div></div> : (
          <table style={{width:'100%',borderCollapse:'collapse',background:'#fff',borderRadius:12,overflow:'hidden',border:'1px solid #e2e8f0'}}>
            <thead><tr style={{background:'#f8fafc'}}>
              {['Device','Rule','State','Reason','Since'].map(h=><th key={h} style={{padding:'10px 16px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748b',borderBottom:'1px solid #f1f5f9'}}>{h}</th>)}
            </tr></thead>
            <tbody>
              {violations.map(s=>{
                const sm = STATE_META[s.state]||{color:'#64748b',bg:'#f1f5f9',label:s.state};
                return (
                  <tr key={s.id} style={{borderBottom:'1px solid #f8fafc'}}>
                    <td style={{padding:'10px 16px',fontWeight:600,fontSize:13}}>{s.device?.hostname||'—'}</td>
                    <td style={{padding:'10px 16px',fontSize:13}}>{s.rule?.name||'—'}</td>
                    <td style={{padding:'10px 16px'}}><span style={{background:sm.bg,color:sm.color,borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700}}>{sm.label}</span></td>
                    <td style={{padding:'10px 16px',fontSize:12,color:'#64748b',maxWidth:220}}>{s.reason||'—'}</td>
                    <td style={{padding:'10px 16px',fontSize:12,color:'#94a3b8'}}>{ts(s.createdAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )
      )}

      {showForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:540,maxWidth:'95vw',maxHeight:'85vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Conditional Access Rule</h3>
            <form onSubmit={save}>
              {[['Name*','name'],['Description','description']].map(([l,k])=>(
                <div key={k} style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                </div>
              ))}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Action</label>
                  <select value={form.action} onChange={e=>setForm({...form,action:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    {Object.entries(ACTION_META).map(([k,v])=><option key={k} value={k}>{v.icon} {v.label}</option>)}
                  </select></div>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Priority (lower = higher)</label>
                  <input type="number" value={form.priority} onChange={e=>setForm({...form,priority:parseInt(e.target.value)})} min="1" max="999" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Conditions (JSON)</label>
                <textarea value={JSON.stringify(form.conditions,null,2)} onChange={e=>{try{setForm({...form,conditions:JSON.parse(e.target.value)})}catch(_){}}} rows={5}
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:12,fontFamily:'monospace',boxSizing:'border-box',resize:'vertical'}} />
                <div style={{fontSize:11,color:'#64748b',marginTop:4}}>
                  Examples: {`{ "complianceScore": {"lt": 50} }`} · {`{ "bitlocker": "off" }`} · {`{ "avEnabled": false }`} · {`{ "lastSeen": {"gt": 1440} }`}
                </div>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create Rule'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
